export default {"src":"/_next/static/media/ready-soon.9668326c.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};